import { ListType } from "./ListType";

export interface IStatus {
  Id: number;
  Name: string;
  Color: number;
  Type: ListType;
  WorkspaceId?: string;
  Global?: boolean;
  GlobalType?: EStatusGlobalType;
}

export enum StatusType {
  // 0 - None, 1 - Incoming, 2 - Outgoing, 3 - Cases, 4 - Tasks, 5 - Drafts, 6 - Participants, 7 - EditorDocuments, 8 - Templates, 9 - Drive, 10 - Shared
  NONE = 0,
  INCOMING = 1,
  OUTGOING = 2,
  CASES = 3,
  TASKS = 4,
  DRAFTS = 5,
  PARTICIPANTS = 6,
  EDITORDOCUMENTS = 7,
  TEMPLATES = 8,
  //Drive = 9,
  //Shared = 10
  INVOICES = 12,
  CONTRACTS = 13,
  ENGAGEMENTS = 14,
}

export enum EStatusGlobalType {
  Send_Waiting = 1,
  Send_Processing = 2,
  Send_ErrorNotRetrayable = 3,
  Send_ErrorRetrayable = 4,
  Send_Sent = 5,

  Signed = 6,
  Send_Delivered = 7,

  Task_Closed = 8,

  Ready = 9,

  Case_Active = 10,
  Case_Rejected = 11,
  Case_Suspended = 12,
  Case_Closed = 13,
  Case_Appeal = 14,
  Case_Other = 15,
  Case_Archival = 16,

  RequestToVerify = 20,
  RequestApproved = 21,
  RequestRejected = 22,
  RequestToBeCompleted = 23,
  RequestOther = 24,
  RequestWrongPersonType = 25,

  Task_Open = 53,

  EDeliveryAccepted = 30,
  EDeliveryRejected = 31,

  EDeliveryRelayAccepted = 32,
  EDeliveryRelayRejected = 33,
  EDeliveryRelayError = 34,

  EDeliveryConsentNotify = 35,
  EDeliveryConsentNotifyError = 36,

  EDeliveryConsentAccepted = 37,
  EDeliveryConsentRejected = 38,
  EDeliveryConsentExpired = 39,

  EDeliveryReceived = 40,
  EDeliveryReceiveError = 41,
}
